import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../theme/ThemeProvider';

type ThemeLabelKey = 'themeLight' | 'themeDark';

const SunIcon: React.FC = () => (
  <svg className="theme-toggle__icon" viewBox="0 0 24 24" role="presentation" aria-hidden="true">
    <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M12 2.5v3M12 18.5v3M21.5 12h-3M5.5 12h-3M17.657 6.343l-2.121 2.121M8.464 15.536l-2.121 2.121M6.343 6.343l2.121 2.121M15.536 15.536l2.121 2.121"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const MoonIcon: React.FC = () => (
  <svg className="theme-toggle__icon" viewBox="0 0 24 24" role="presentation" aria-hidden="true">
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3a7.5 7.5 0 0 0 9.79 9.79Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ThemeToggle: React.FC = () => {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation('common');

  const label = t('themeToggleLabel');
  const themeLabelKey: ThemeLabelKey = theme === 'dark' ? 'themeDark' : 'themeLight';
  const modeLabel = t(themeLabelKey);
  const ariaLabel = `${label} (${modeLabel})`;

  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={ariaLabel}
      title={ariaLabel}
      onClick={toggle}
      data-theme-mode={theme}
    >
      {theme === 'dark' ? <MoonIcon /> : <SunIcon />}
    </button>
  );
};

export default ThemeToggle;
